export default "__VITE_ASSET__yQgmY$QG__"